<template lang="pug">
  v-row.px-1(no-gutters)
    v-card.mt-3(flat width='100%')
      v-card-title.mx-3
        h4 {{ $t('waiting-deposit') }}
      v-divider
      v-card-text 
        v-row(no-gutters justify="center") 
          v-col(cols=12 md=8)
            h3.mx-3 {{ $t('payment-method') }}
            v-list-item
              v-avatar.mr-3(
                :color='secondIcon'
                size='30'
              )
                h2 1
              v-list-item-content {{ $t('desc.waiting-confirm-amount-deposit') }}
                div(v-if='!notDeposit')
                  | {{ $t('with-in') }} 
                  b
                    mark {{ countDownTimeString }}
                div(v-else)
                  b
                    mark.success--text  {{ $t('status') }} {{ (bankInfo.status || {}).name }} 
            .d-flex.justify-center.mt-2
              v-card(width='98%', outlined)
                v-row(no-gutters justify="center", align="center").px-4
                  v-col(cols=12 sm=6, order=2 order-sm=1)
                    v-list-item.bank-item
                      v-avatar(v-if="!isRedirectPayment").mt-2
                        v-img(:src='bankIconPath(bankInfo.admin_bank.bank_type.id)')
                      v-list-item-content.justify-center
                        div(v-if="!isRedirectPayment").bank-base-info
                          div {{ bankInfo.admin_bank.bank_type.name }}
                          b(v-if="isShowBank").mt-2.text-info {{ bankInfo.admin_bank.number }}
                          div.mt-2 {{ bankInfo.admin_bank.name }}
                          br
                          strong(v-if="isZman || isShowQr").red--text
                            | *โปรดใช้บัญชี ที่ท่านลงทะเบียนไว้ในการชำระเงิน เท่านั้น
                        .mt-1
                          v-btn(
                            v-if="(!isRedirectPayment && isShowBank && !isShowQr && !isHideCopy)"
                            block
                            dark
                            depressed
                            color='var(--bg-main-color)'
                            @click='copyText(bankInfo.admin_bank.number)'
                          ) {{ $t('button.copy') }}
                        br
                        | {{ $t('total-payment') }}
                        .mt-1
                          mark.text-center
                            h1 {{ bankInfo.request_amount | currency }}
                            v-card-actions(v-if='!notDeposit')

                        //- .mt-1
                        //-   v-btn(
                        //-     v-if="bankInfo.admin_bank.qr_image_url"
                        //-     block
                        //-     dark
                        //-     depressed
                        //-     color='var(--bg-main-color)'
                        //-     @click='copyText(bankInfo.request_amount)'
                        //-   ) คัดลอกยอดชำระ
                    .mt-2(v-if='isShowUploadSlip && isCanConfirm')
                      v-card.my-2(
                        class="pa-4 text-center rainbow-box"
                        outlined
                        style="cursor:pointer"
                        @click="$refs.file.click()"
                      )
                        input(ref="file" type="file" accept="image/*" style="display:none" @change="onFileChange")

                        template(v-if="!preview")
                          v-img(src="@/assets/qr-placeholder.png" max-width="80" max-height="100" contain class="mx-auto")
                          div.mt-2.grey--text กรุณาอัปโหลดรูปภาพสลิปโอนเงิน

                        template(v-else)
                          v-img(:src="preview" max-width="300" contain class="mx-auto")

                      div.red--text.mt-2(v-if="errorMessage")
                        | {{ errorMessage }}

                      v-btn(
                        block
                        dark
                        depressed
                        color='var(--bg-secondary-color)'
                        :loading='submitStatus'
                        height='46'
                        style='font-size: 1.125rem; font-weight: 700;'
                        @click='submitSlip'
                      ).mt-2 ยืนยันสลิปโอนเงิน

                      v-btn(
                        v-if="isRedirectPayment && bankInfo.redirect_to"
                        block
                        dark
                        depressed
                        color='var(--bg-secondary-color)'
                        :href='bankInfo.redirect_to'
                        target='_blank'
                      ).mt-2
                        v-icon.mr-1(small) mdi-open-in-new
                        | ไปยังหน้าชำระเงิน

                      v-btn(
                        v-if="!isRetryChannel"
                        block
                        depressed
                        @click='cancelTopup'
                      ).mt-2.mb-2 {{ $t('button.cancel-deposit-amount') }}

                      canvas(ref="canvas" style="display: none;")
                    div(v-if='isCanConfirm && !isShowUploadSlip')
                      v-btn(
                        v-if="!isRedirectPayment && !isZman && !isShowQr && !isPresetGatePayment"
                        block
                        depressed
                        color='var(--bg-secondary-color)'
                        dark
                        @click='paymentInfo'
                      ).mt-2 {{ $t('button.deposit-amount') }}
                      v-btn(
                        v-if="isRedirectPayment && bankInfo.redirect_to"
                        block
                        depressed
                        dark
                        color='var(--bg-secondary-color)'
                        :href='bankInfo.redirect_to'
                        target='_blank'
                      ).mt-2
                        v-icon.mr-1(small) mdi-open-in-new
                        | ไปยังหน้าชำระเงิน
                      v-btn(
                        v-if="!isRetryChannel"
                        block
                        depressed
                        @click='cancelTopup'
                      ).mt-2 {{ $t('button.cancel-deposit-amount') }}
                    v-btn(
                      v-if="isCanConfirm"
                      block
                      depressed
                      :ripple="false"
                      @click="goToLineAgent"
                    ).mt-3.mb-4
                      span.mr-1 {{ $t('button.report-problem-topup-line') }}
                      v-img(
                        max-width="20"
                        :src="require('@/assets/socials/line.svg')"
                      )
                  v-col(v-if="bankInfo.admin_bank.qr_image_url" cols=12 sm=4, order=1 order-sm=2)
                    div.my-1.px-5
                      div.onetime-title {{ $t('hint.deposit-one-time') }}
                      v-img(:src='bankInfo.admin_bank.qr_image_url', width="100%")
                      div.onetime-title {{ $t('hint.deposit-one-time') }}
                    div.mb-5
                      v-btn(
                        block
                        dark
                        depressed
                        color='var(--bg-main-color)'
                        @click='download_qr'
                      ) บันทึกภาพ QR code
            v-list-item.mt-2
              v-avatar.mr-3(
                :color='secondIcon'
                size='30'
              )
                h2 2
              v-list-item-content {{ $t('desc.keep-evidence-deposit') }}
            v-list-item.mt-2
              v-avatar.mr-3(
                :color='secondIcon'
                size='30'
              )
                h2 3
              v-list-item-content {{ $t('desc.waiting-deposit') }}
    dialog-inform(
      ref='dialog'
      @next='nextPage'
    )
</template>
<script> 
import { credits as apiCredits, agentInfo as apiAgentInfo } from '@/apis'
import { getMinuteTime } from '@/plugins/time' 
import { bankIconPath } from '@/plugins/mapImage'
import dialogInform from './dialogInform.vue'
import jsQR from 'jsqr'
import * as c from '@/const/setTimeOutConfig'
import { ROUTE_DEPOSIT,ROUTE_INDEX, ROUTE_TRASACTION } from '@/const/route'

const PAPAYA_PAY = 17
const BITPAY = 23
const ZMAN = 33
const JJ = 36
const WORLDPAY = 37
const ANY_PAY = 38
const P2W = 40
const CBP = 41
const MATTPAY = 45
const LINK_DEEP_CODE = 46
const WORLDPAY_PG = 52
const NEXVO = 44
const NEXVO2 = 47
const OKEX_PAY = 49
const OMEGA_PAY = 55
const PRIME_PAY = 58
const THOR_PAY = 59

const RETRY_CHANNELS = [LINK_DEEP_CODE, WORLDPAY_PG, PRIME_PAY]

export default {
  components : {
    dialogInform, 
  },  
  props : {
    bankInfo : {
      type : Object,
      default : () => {}
    }
  },
  data () {
    return { 
      secondIcon:'grey', 
      countDownTime:this.bankInfo.expire_in, 
      copyAccountNumberText:this.$t('copy-account-number'),  
      uuid : this.bankInfo.uuid,
      notDeposit:false,
      agentInfo: {},
      submitStatus : false,
      slip : null,
      preview : null,
      errorMessage : null,
      requestQrString : null
    }
  },
  computed : {
    PAPAYA_PAY () { return PAPAYA_PAY},
    countDownTimeString () {
      return getMinuteTime(this.countDownTime)
    },
    isCanConfirm () {
      return this.bankInfo.request_confirmed_at === null
    },
    isPresetGatePayment () {
      return !!this.bankInfo.is_preset_gate
    },
    isRedirectPayment () {
      return [PAPAYA_PAY, LINK_DEEP_CODE, OKEX_PAY].includes(this.bankInfo.admin_bank.bank_type.id)
    },
    isRetryChannel () {
      return RETRY_CHANNELS.includes(this.bankInfo.pg_bank_type_id)
    },
    isZman () {
      return this.bankInfo.admin_bank.bank_type.id == ZMAN
    },
    isShowQr () {
      const qrBanks = [BITPAY, JJ, WORLDPAY, ANY_PAY, P2W, CBP, MATTPAY];
      return qrBanks.includes(this.bankInfo.admin_bank.bank_type.id);
    },
    isHideCopy () {
      const hideCopyBanks = [NEXVO, NEXVO2];
      return hideCopyBanks.includes(this.bankInfo.admin_bank.bank_type.id);
    },
    isShowBank () {
      return !this.bankInfo.redirect_to
    },
    isShowUploadSlip () {
      if (this.bankInfo.preset_gate_upload_slip) return true;
      const uploadSlipBanks = [LINK_DEEP_CODE, NEXVO2, NEXVO, WORLDPAY_PG, OMEGA_PAY, THOR_PAY, PRIME_PAY];
      const id = this.bankInfo.pg_bank_type_id ?? this.bankInfo.admin_bank.bank_type.id;
      return uploadSlipBanks.includes(id);
    },
  },
  watch : {
    countDownTime () {
      if(this.countDownTime===0){
        this.$alert('',this.$t('message.timeout-deposit-confirm'),'warning')  
      }
    }
  },  
  async created () {
    this.loadAgentInfo()

    if((this.bankInfo.status || {}).id!==2){
      this.countDownTimer ()
    } else {
      this.notDeposit = true
    }
  },
  methods : {
    bankIconPath,
    async loadAgentInfo () {
      const [err, data] = await apiAgentInfo.get()
      if (err) return
      this.agentInfo = data || {}
    },
    goToLineAgent () {
      const url = `http://line.me/ti/p/~${this.agentInfo.line_id}`
      window.open(url, '_blank')
    },
    redirectToindex () {
      if(this.countDownTime===0){
        this.$router.push({
          name:ROUTE_TRASACTION
        }).catch(()=>{});  
      } else{
        this.$router.push({
          name:ROUTE_INDEX
        }).catch(()=>{});  
      } 
    },
    async cancelTopup () {
      this.$ga.event('Button', 'CancelDeposit', 'DepositPage','' )

      if(this.isPresetGatePayment){
        this.$emit('cancel')
        return
      }

      const [err,] = await apiCredits.cancel(this.bankInfo.uuid)
      
      if(err) {
        this.$alert('',err,'warning').then(()=>{ 
          this.redirectToindex() 
        }) 
        return
      }
    
      this.$router.push({
        name:ROUTE_INDEX
      }).catch(()=>{});    
    },
    countDownTimer () {  
      if(this.$route.name !== ROUTE_DEPOSIT){
        return
      }

      if(this.countDownTime > 0) {
        setTimeout(() => {
            this.countDownTime -= 1 
            this.countDownTimer()
        }, c.COUNTDOWNONESEC)
      } else  {
        this.cancelTopup()
      }
    },
    async copyText (text) {
      try {
        await navigator.clipboard.writeText(text);
        alert('คัดลอกสำเร็จ');
      } catch($e) {
        alert('ไม่สามารถคัดลอกได้');
      }
    },
    copyAccountNumber () {
      this.$ga.event('Button', 'CoppyAccountNumber', 'DepositPage','' )
      this.copyAccountNumberText = this.$t('copied-account-number')
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy); 
      dummy.value = this.bankInfo?.admin_bank?.number;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);     
          
      setTimeout(()=>
        this.copyAccountNumberText = this.$t('copy-account-number') 
        ,c.COPYACCOUNTTOPUP) 
    },
    async download_qr () {
      const blob = await fetch(this.bankInfo.admin_bank.qr_image_url).then(res => res.blob())
      const url = URL.createObjectURL(blob)
      const a = Object.assign(document.createElement('a'), {
        href: url,
        download: '', // or leave blank to let the browser decide
      })
      document.body.append(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(url)

      alert('บันทึกสำเร็จ');
    },
    nextPage () {
      //แจ้งถอนนะจ๊ะ
      this.$emit('next')
    } ,
    paymentInfo () {
      this.$ga.event('Button', 'OpenDialogInform', 'DepositPage','' )
      this.$refs.dialog.openDialog(this.bankInfo.request_amount,this.uuid)
    },
    onFileChange (event) {
      this.requestQrString = null
      this.errorMessage = ""
      this.preview = null
      this.slip = null

      const file = event.target.files[0]
      if (!file) return

      this.slip = file
      this.preview = URL.createObjectURL(file)

      this.readQR(file)
    },
    readQR (selectedFile) {
      this.requestQrString = null
      this.errorMessage = ""

      if (!selectedFile) return

      const imageFile = Array.isArray(selectedFile)
        ? selectedFile[0]
        : selectedFile

      const reader = new FileReader()

      reader.onload = (e) => {
        const img = new Image()
        img.src = e.target.result

        img.onload = () => {
          const canvas = this.$refs.canvas
          const ctx = canvas.getContext("2d", { willReadFrequently: true })

          const MAX_WIDTH = 800

          const scale = Math.min(MAX_WIDTH / img.width, 1)
          canvas.width = img.width * scale
          canvas.height = img.height * scale

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

          const imageData = ctx.getImageData(
            0,
            0,
            canvas.width,
            canvas.height
          )

          const code = jsQR(
            imageData.data,
            imageData.width,
            imageData.height
          )

          if (code) {
            this.requestQrString = code.data
          } else {
            this.errorMessage = "ไม่พบ QR Code ในรูปภาพนี้"
          }
        }
        img.onerror = () => {
          this.errorMessage = "ไฟล์รูปภาพไม่ถูกต้อง หรือไม่สามารถอ่านได้"
        }
      }

      reader.readAsDataURL(imageFile)
    },
    async submitSlip () {
      if (this.submitStatus) {
        return
      }

      if (!this.requestQrString) {
        this.errorMessage = "กรุณาอัปโหลดรูปภาพสลิปโอนเงิน"
        return
      }

      if (this.isPresetGatePayment) {
        this.$emit('preset-gate-slip', {
          uuid: this.bankInfo.admin_bank.uuid,
          bank_type: this.bankInfo.admin_bank.bank_type,
          qr: this.requestQrString,
        })
        return
      }

      this.submitStatus = true

      if (typeof window.ga === 'function') {
        window.ga('send', 'event', 'Button', 'Deposit', 'DepositPage', '')
      }

      let params = new FormData()

      params.append('request_qr_string', this.requestQrString)

      if (this.slip) {
        params.append('slip', this.slip)
      }

      const [err,] = await apiCredits.confirmFormData(this.uuid,params)

      if(err) {
        this.submitStatus = false
        this.$alert('',err,'warning')
        return
      }

      this.submitStatus = false
      this.$emit('next')
    }
  }
}
</script>
<style scoped>
.bank-item {
  align-items: flex-start;
  gap: 16px;
}

.bank-base-info {
  display: flex;
  flex-direction: column;
}

.text-info {
  font-size: 1.125rem;
}

.onetime-title {
  text-align: center;
  color: red;
  font-size: 0.925rem;
}

.rainbow-box {
  border: 3px solid transparent;
  border-radius: 12px;

  background:
    linear-gradient(white, white) padding-box,
    linear-gradient(to bottom right,
      #b827fc 0%,
      #2c90fc 25%,
      #b8fd33 50%,
      #fec837 75%,
      #fd1892 100%
    ) border-box;
}
</style>
